import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, vShow as _vShow, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "section timetableblock" }
const _hoisted_2 = { class: "container-fluid" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-12 program" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("svg", { class: "icon-help" }, [
  /*#__PURE__*/_createElementVNode("use", { href: "#icon-help" })
], -1)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = {
  class: "col-12 soundwave scroll-snapping",
  ref: "soundwave"
}
const _hoisted_8 = {
  ref: "hints",
  class: "hint"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("svg", { class: "icon-gesture gesture-swipe-right" }, [
  /*#__PURE__*/_createElementVNode("use", { href: "#icon-gesture" })
], -1)
const _hoisted_10 = [
  _hoisted_9
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ContentfulRichText = _resolveComponent("ContentfulRichText")!
  const _component_SetList = _resolveComponent("SetList")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h2", null, _toDisplayString(_ctx.cms.pageTitle), 1),
          _createElementVNode("div", {
            class: "legenda",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleLegend && _ctx.handleLegend(...args)))
          }, _hoisted_6)
        ]),
        _createElementVNode("div", _hoisted_7, [
          _withDirectives(_createElementVNode("p", _hoisted_8, _hoisted_10, 512), [
            [_vShow, _ctx.showHints]
          ]),
          _createVNode(_component_ContentfulRichText, {
            document: _ctx.cms.intro,
            class: "intermezzo"
          }, null, 8, ["document"]),
          (_ctx.cms.firstSetlist?.length > 0)
            ? (_openBlock(), _createBlock(_component_SetList, {
                key: 0,
                set: _ctx.cms.firstSetlist
              }, null, 8, ["set"]))
            : _createCommentVNode("", true),
          _createVNode(_component_ContentfulRichText, {
            document: _ctx.cms.intermezzoRte,
            class: "intermezzo"
          }, null, 8, ["document"]),
          (_ctx.cms.lastSetlist?.length > 0)
            ? (_openBlock(), _createBlock(_component_SetList, {
                key: 1,
                set: _ctx.cms.lastSetlist
              }, null, 8, ["set"]))
            : _createCommentVNode("", true)
        ], 512)
      ])
    ])
  ]))
}